import React from 'react';

import { useTranslation } from 'react-i18next';

import { IFinanceExportReport } from '@entities/financeExportReport';
import { useDialog } from '@shared/hooks';
import { Icon, Popup, UiButton } from '@shared/ui';

import cls from './ReportActions.module.css';

interface ReportActionsProps {
    report: IFinanceExportReport;
    onDelete: (id: number) => void;
    onRetry: (id: number) => void;
    onDownload: (fileUrl: string) => void;
}

export const ReportActions = ({ report, onDelete, onRetry, onDownload }: ReportActionsProps) => {
    const { t } = useTranslation();
    const { isOpen, open, close } = useDialog();

    return (
        <div className={cls.actions}>
            {isOpen && (
                <Popup
                    type="delete"
                    btnActionCb={() => onDelete(report.id)}
                    deleteButtonText={t('button.delete.text')}
                    isOpen={isOpen}
                    onHidePopup={close}
                    title={t('ReportActions.return.actions.Popup.title')}
                />
            )}
            {report.status === 'failed' && (
                <UiButton
                    variant="icon"
                    className={cls.actionBtn}
                    onClick={() => onRetry(report.id)}
                    startIcon={<Icon iconName="reload" width={16} height={16} />}
                />
            )}
            {report.status === 'done' && (
                <UiButton
                    variant="icon"
                    className={cls.actionBtn}
                    onClick={() =>
                        onDownload(
                            report.actions.find((action) => action.type === 'download')?.url
                        )
                    }
                    startIcon={
                        <Icon
                            iconName="filesDownload"
                            fill="currentColor"
                            width={16}
                            height={16}
                        />
                    }
                />
            )}
            <UiButton
                variant="icon"
                className={cls.actionBtn}
                onClick={open}
                startIcon={<Icon iconName="delete" fill="currentColor" width={16} height={16} />}
            />
        </div>
    );
};
